export const TABS = {
  MAIN: "main",
  SUMMARIES: "summaries",
  HELP: "help",
}

// Constants representing different AiMS availability and behavior statuses
export const AIMS_STATUS = {
  // AiMS is available for this meeting, both the organizer and attendees will receive the summary
  AVAILABLE: "AimsAvailable",

  // AiMS is partially available, only the organizer will receive the summary
  SUMMARY_TO_ORGANIZER: "SummaryToOrganizer",

  // AiMS is not available for this meeting (e.g., due to legal policy)
  NOT_AVAILABLE: "AimsNotAvailable",

  // The meeting has external attendee
  EXTERNAL_ATTENDEE: "ExternalAttendee",

  // AiMS failed due to an unexpected error (could be from frontend or backend)
  EXCEPTION: "AimsException",
};

export const TRANSCRIPT_START_CHAT_MESSAGE = 'Amazon uses artificial intelligence technology ("AI") to summarize videoconference calls. By using the AiMS application, you understand Amazon will briefly transcribe and analyze your communications for these purposes. If you do not agree to meeting summarization, remain on mute, leave the meeting, or ask the organizer to stop summarizing the meeting at any time.';
